import { LoadableAfterPaint, LoadableLazy } from '@confluence/loadable';

export const SourcesList = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsSourcesList" */ './components/SourcesList'
			)
		).SourcesList,
});

export const GlobalImportModal = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-globalImportModal" */ './components/Modals/GlobalImportModal/GlobalImportModal'
			)
		).GlobalImportModal,
});
